@if (shouldRenderComponent(textKey | text)) {
  @if (shouldRenderPopover(textKey | text)) {
    <nxt-info-icon
      [aria-label]="fullAriaLabel"
      [aria-labelledby]="ariaLabelledBy ? 'info_icon_aria_labelled_by_prefix ' + ariaLabelledBy : ''"
      [negative]="invertColor"
      [ngClass]="margin ? 'nx-margin-left-2xs' : 'nx-margin-left-0'"
      data-cy="icon-info-popover"
      type="popover">
      <ng-container *ngTemplateOutlet="presenterContent; context: { dataCy: 'info-icon-popover' }"></ng-container>
    </nxt-info-icon>
  } @else {
    <nxt-info-icon
      (click)="openFromTemplate()"
      (keydown.enter)="openFromTemplate(); $event.preventDefault()"
      [aria-label]="fullAriaLabel"
      [aria-labelledby]="ariaLabelledBy ? 'info_icon_aria_labelled_by_prefix ' + ariaLabelledBy : ''"
      [negative]="invertColor"
      [ngClass]="margin ? 'nx-margin-left-2xs' : 'nx-margin-left-0'"
      type="button"></nxt-info-icon>
  }
  <ng-template #popover>
    <nxt-info-icon
      [aria-label]="fullAriaLabel"
      [aria-labelledby]="ariaLabelledBy ? 'info_icon_aria_labelled_by_prefix ' + ariaLabelledBy : ''"
      [negative]="invertColor"
      [ngClass]="margin ? 'nx-margin-left-2xs' : 'nx-margin-left-0'"
      data-cy="icon-info-popover"
      type="popover">
      <ng-container *ngTemplateOutlet="presenterContent; context: { dataCy: 'info-icon-popover' }"></ng-container>
    </nxt-info-icon>
  </ng-template>
}

<ng-template #modalTemplate>
  <div data-cy="icon-info-modal">
    <div
      nxModalContent
      class="nx-margin-bottom-2m">
      <ng-container *ngTemplateOutlet="presenterContent; context: { dataCy: 'info-icon-modal' }"></ng-container>
    </div>
    <div nxModalActions>
      <button
        (click)="closeModal()"
        class="nx-margin-bottom-0"
        nxButton="primary small"
        type="button">
        {{ closeBtnText }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template
  #presenterContent
  let-dataCy="dataCy">
  @if (modalTitle) {
    <h3
      nxHeadline="subsection-medium"
      class="nx-margin-bottom-0">
      <strong>{{ modalTitle }}</strong>
    </h3>
  }
  <p
    [attr.data-cy]="dataCy + '-text'"
    [innerHTML]="(textContent | text) || (textKey | text)"
    class="presenter-content nx-margin-bottom-0 nx-margin-top-0"
    nxCopytext="large"></p>
</ng-template>

<span
  [innerHTML]="this.ariaLabelPrefix"
  id="info_icon_aria_labelled_by_prefix"
  class="u-display-none"></span>
